import { mapActions, mapGetters } from 'vuex';

const CTACommon = {

  data() {
    return {
      CTAdialogVisible: false,
    };
  },



  computed: {
    ...mapGetters('Home', ['isExtConnected']),
    ...mapGetters('users', ['userCompanyId']),
  },

  methods: {
    ...mapActions('Home', ['isExtCreditCardConnected', 'dontShowCreditDialog']),
    CTAhandleParentComfirm() {
      this.dontShowCreditDialog({ companyId: this.userCompanyId });
      this.CTAdialogVisible = false;
    },

    CTAhandleClose() {
      this.CTAdialogVisible = false;
    },
  },
};

export default CTACommon;
